import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_PAYEE } from "..";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";
import {
  GetMissingFieldsLevelParameter,
  RequirementType
} from "@wingspanhq/wingspan-api-sdk";
import { queriesRequirements } from "@query";
import { useSession } from "@hooks/useSession";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { useMemo } from "react";

export const RouteTaxPayeeOnboarding: React.FC = () => {
  const history = useHistory();
  const { accountId } = useSession();
  const queryFeatureFlags = useQueryFeatureFlags();

  // TODO(v3-blocker): v1 also filtered on `payerPayeeEngagementIds != null`;
  // v3 `listPayeeRequirements` has no existence operator, so that constraint
  // is dropped.
  const queryRequirements =
    queriesRequirements.listPayeeRequirements.useQueryAll(
      {
        filter: {
          payeeAccountId: { in: [accountId] },
          type: { in: [RequirementType.PAYOUT_METHOD] }
        }
      },
      { enabled: !!accountId }
    );

  const requirements = queryRequirements.flatData || [];

  const hasPayoutMethodRequirement = requirements.some(
    requirement => requirement.type === RequirementType.PAYOUT_METHOD
  );

  const taxPayeeOnboardingModules: OnboardingModule[] = useMemo(() => {
    const steps: OnboardingModule[] = [
      {
        type: "create_account",
        options: {
          accountTypes: ["Business", "Individual"],
          verificationLevel: GetMissingFieldsLevelParameter.TAX,
          show1099Message: true,
          allowUSInternationalPerson:
            queryFeatureFlags.data?.internationalUsPerson
        }
      },
      {
        type: "certify_tax_payer_info"
      }
    ];

    if (hasPayoutMethodRequirement) {
      steps.push({
        type: "payout_method"
      });
    }

    return steps;
  }, [
    hasPayoutMethodRequirement,
    queryFeatureFlags.data?.internationalUsPerson
  ]);

  return (
    <OnboardingFlow
      isLoading={queryRequirements.isInitialLoading}
      basePath={PATH_ONBOARDING_TAX_PAYEE}
      modules={taxPayeeOnboardingModules}
      onSuccess={() => {
        history.push("/member/dashboard");
      }}
    />
  );
};
